/* W2 extras. Instant checkout on the product page.
   Shopify renders its wallet buttons (Apple Pay, Google Pay, Shop Pay, PayPal) inside
   [data-wallets] whenever the store's card provider offers them. As soon as a real wallet
   button appears, it takes the place of our "Kaupa núna". Otherwise our Icelandic button stays. */
(function () {
  var box = document.querySelector('[data-express]');
  if (!box) return;
  var wallets = box.querySelector('[data-wallets]');
  if (!wallets) return;
  var WALLET = /^shopify-(apple-pay|google-pay|shop-pay|paypal|amazon-pay)/i;
  function hasWallet(root) {
    var ac = root.querySelector('shopify-accelerated-checkout');
    if (ac) {
      try {
        var rec = JSON.parse(ac.getAttribute('recommended') || 'null');
        if (rec && rec.name && rec.name !== 'buy_it_now') return true;
      } catch (e) {}
    }
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (WALLET.test(all[i].tagName)) return true;
      if (all[i].shadowRoot && hasWallet(all[i].shadowRoot)) return true;
    }
    return false;
  }
  function check() {
    if (hasWallet(wallets)) { box.classList.add('has-wallet'); return true; }
    return false;
  }
  if (check()) return;
  if (!window.MutationObserver) return;
  var mo = new MutationObserver(function () { if (check()) mo.disconnect(); });
  mo.observe(wallets, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 15000);
})();

/* Keep the chat bubble out of the way while the buy box or the newsletter form is on screen (phones). */
(function () {
  var targets = document.querySelectorAll('.w2-buy, .w2-news');
  if (!targets.length || !('IntersectionObserver' in window)) return;
  var seen = new Set();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
    document.body.classList.toggle('w2-buy-in-view', seen.size > 0);
  }, { rootMargin: '0px 0px -40px 0px' });
  targets.forEach(function (t) { io.observe(t); });
})();
